import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";
import PelodExampleRows from "../model";
import PelodScore from "../create";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";
import ByzNurseAddButton  from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseAddButton";
import ByzNursePrintButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton";
//IDOGAN;446031;07022025
const columns: GridColDef[] = [
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return (
        <Link to={`edit/${params.row.id}`}>
          <EditIcon color="info" />
        </Link>
      );
    },
  },
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <IconButton onClick={() => console.log(params.row.id)}>
        <DeleteIcon color="error" />
      </IconButton>
    ),
  },
];

function PelodScoreList() {
  return (
    <BaseMedCardList
      title="Pelod Skoru"
      columns={columns}
      rows={PelodExampleRows}
      CreateComponent={PelodScore}
      pageSize={10}
    />
  );
}

export default PelodScoreList;
